import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import EmblaCarousel from '~/start/components/EmblaCarousel'
import { testimonialItems } from '~/start/constants'

export default function TestimonialsSection({
  background,
  isLandingPageV2FAQ = false,
}: {
  background?: string
  isLandingPageV2FAQ?: boolean
}): React.ReactElement {
  const { t } = useTranslation('start')

  return (
    <div className={`overflow-hidden ${background ?? 'bg-gradient-tod-heading'} text-white`}>
      <div className="px-3 lg:pl-6 md:pr-0 mx-auto">
        <div className="flex flex-col text-center mx-auto">
          <h2
            className={`pt-6 md:leading-12 font-bold ${
              isLandingPageV2FAQ ? 'text-6 md:text-10 capitalize' : 'text-2xl md:text-h1 uppercase'
            }`}
          >
            {t('testimonials.realStories')}
          </h2>
          <p className={`pt-2 text-blue-pastel mx-auto ${isLandingPageV2FAQ ? '' : 'text-md'}`}>
            {t('testimonials.familiesShare')}
          </p>
        </div>
        <div className="mx-auto py-8">
          <div className="flex flex-col gap-10 gap- md:gap-15">
            <div className="text-white w-full">
              <EmblaCarousel
                options={{ loop: true, align: 'start' }}
                renderButtons={(scrollPrev, scrollNext) => (
                  <div className="flex items-center justify-center gap-10 md:mt-10 mx-auto lg:-ml-6">
                    <button
                      className="flex justify-center items-center rounded-full p-4 border-2 border-black bg-white hover:scale-110 duration-300"
                      onClick={scrollPrev}
                      title="Slider Previous"
                    >
                      <svg fill="none" height="14" width="16" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.833 13 1 7m0 0 5.833-6M1 7h14"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        />
                      </svg>
                    </button>
                    <button
                      className="flex justify-center items-center rounded-full p-4 border-2 border-black bg-white hover:scale-110 duration-300"
                      onClick={scrollNext}
                      title="Slider Next"
                    >
                      <svg fill="none" height="14" width="16" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.167 1 15 7m0 0-5.833 6M15 7H1"
                          stroke="black"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                        />
                      </svg>
                    </button>
                  </div>
                )}
              >
                {testimonialItems?.map((review) => (
                  <div
                    className="basis-full md:basis-7/12 2xl:basis-6/12 flex-shrink-0 flex-grow-0 md:pr-4"
                    key={review.id}
                  >
                    <div className="flex flex-col gap-6 md:gap-0 md:flex-row md:items-center">
                      {review.image?.srcKey && (
                        <ResponsiveImage
                          alt={t(review.image.alt)}
                          height={540}
                          imageClassName="rounded border-2 border-purple mx-auto"
                          srcKey={review.image.srcKey}
                          width={455}
                        />
                      )}
                      <div className="flex text-center flex-col gap-6 md:text-left md:pl-6">
                        {review.text && (
                          <div className="max-w-132 mx-auto">
                            <p>{t(review.text)}</p>
                          </div>
                        )}
                        {(review.author || review.subinfo) && (
                          <div className="flex flex-col text-center md:text-left">
                            {review.author && <p className="font-bold">{t(review.author)}</p>}
                            {review.subinfo && <p className="relative">{t(review.subinfo)}</p>}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </EmblaCarousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
